import getSessionId from '../../getSessionId';
import {redirect} from './redirect';

export function ajax(type, path, data = null) {
  const sessionId = getSessionId();
  if (!sessionId) {
    redirect.toRedirectPage();
    return Promise.reject();
  }
  
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200 || xhr.status === 202) {
          if (xhr.responseText) {
            try {
              resolve(JSON.parse(xhr.responseText));
            } catch (error) {
              reject(error);
            }
          } else {
            resolve();
          }
        } else if (xhr.status) {
          try {
            reject(JSON.parse(xhr.responseText).error);
          } catch (error) {
            reject(error);
          }
        } else {
          reject(new Error('An error occurred whilst sending the request.'));
        }
      }
    };
    
    xhr.open(type, path, true);
    xhr.setRequestHeader('sessionId', sessionId);
    xhr.setRequestHeader('x-thg-client', 'checkout-web-js');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(data));
  });
}

export function post(path, data) {
  return ajax('POST', path, data);
}

export function get(path) {
  return ajax('GET', path);
}
